import { useEffect, useState } from "react";
import Threads from "@/components/ui/Threads";

/** Threads canvas scoped to a hero section - scrolls with the page. */
export function ServicesHeroThreads() {
  const [isDark, setIsDark] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDark = () =>
      setIsDark(document.documentElement.classList.contains("dark"));
    const checkMobile = () => setIsMobile(window.innerWidth < 768);

    checkDark();
    checkMobile();

    const observer = new MutationObserver(checkDark);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    window.addEventListener("resize", checkMobile);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true">
      <Threads
        color={isDark ? [1, 1, 1] : [0.1, 0.1, 0.3]}
        amplitude={isMobile ? 1.2 : 1.8}
        distance={0.4}
        enableMouseInteraction={!isMobile}
        className="w-full h-full"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/25 to-background/70" />
    </div>
  );
}
